<template>
  <div>
    <v-list-tile
      :style="selected ? 'background-color: #eee' : ''"
      class="noPaddingLeft"
      avatar
      ripple
      @click="clicOnlistItem()"
    >
      <v-list-tile-avatar style="min-width: 42px;">
        <v-icon color="blue">mdi-file-document</v-icon>
      </v-list-tile-avatar>

      <v-list-tile-content style="width: min-content;">
        <template v-if="two_line_variant == false">
          <v-list-tile-title style="width: 90%; line-height: 28px;">
            <span class="text--truncate">
              <strong>{{ invoice.company_name || (invoice.company && invoice.company.name) }}</strong>
            </span>
          </v-list-tile-title>
          <v-list-tile-sub-title style="white-space: nowrap;">
            <span style="font-size: 12px; width: 100%;">
              Ref:
              <strong class="text--truncate">{{ invoice.designation }}</strong>
            </span>
          </v-list-tile-sub-title>
        </template>

        <template v-else>
          <v-list-tile-title style="width: 90%; line-height: 28px;">
            <span class="text--truncate">
              Ref:
              <strong class="text--truncate">{{ invoice.designation }}</strong>
            </span>
          </v-list-tile-title>
        </template>

        <v-list-tile-sub-title style="white-space: nowrap;">
          <v-layout row align-center class="ma-0">
            <span>
              <span
                :class="
                  'pr-3 caption font-weight-bold ' +
                  (invoice.operation_type == 'debit' ? 'ctcRed' : 'ctcGreen') +
                  '--text'
                "
                >{{ invoice.operation_type == "debit" ? "-" : "+"
                }}{{
                  inCurrencyFromId(invoice.currency_id, invoice.amount)
                }}</span
              >

              <v-tooltip bottom color="blue" dark>
                <a
                  @click.stop="toggleFilePreview()"
                  slot="activator"
                  class="caption blue--text pl-2"
                >
                  <v-icon
                    color="blue"
                    style="
                      position: relative;
                      top: -1px;
                      width: 12px;
                      height: 12px;
                    "
                    >mdi-menu-{{ showFilePreview ? "up" : "down" }}</v-icon
                  >
                  {{ invoice.document_url }}
                </a>
                <span style="color: white;">
                  <span v-if="!showFilePreview">
                    <v-icon small class="pr-2" color="white"
                      >mdi-file-search</v-icon
                    >Clic to preview the invoice file
                  </span>
                  <span v-else>Close file preview</span>
                </span>
              </v-tooltip>
            </span>
          </v-layout>
        </v-list-tile-sub-title>
      </v-list-tile-content>

      <v-list-tile-action
        v-if="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm"
        style="min-width: fit-content;"
      >
        <v-list-tile-action-text>
          <span
            v-if="invoice.invoice_date"
            style="white-space: nowrap; float: right;"
          >
            <v-icon size="13" color="grey">update</v-icon>
            {{ timeToDate(invoice.invoice_date) }}
          </span>
          <span v-else style="white-space: nowrap; float: right;">
            <v-icon size="13" color="error">warning</v-icon>
            <span class="error--text">Missing</span>
          </span>
          <br />
          <v-chip
            style="float: right;"
            class="ma-0 mt-1"
            dark
            :color="invoice.account_type.color"
          >
            <!-- catching weird null string -->
            <v-icon
              v-show="
                invoice.account_type.icon && invoice.account_type.icon != 'null'
              "
              class="pr-1"
              size="11"
              style="position: relative; top: -1px;"
              >{{ invoice.account_type.icon }}</v-icon
            >
            {{ invoice.account_type.name }}
          </v-chip>
        </v-list-tile-action-text>
      </v-list-tile-action>
    </v-list-tile>
    <filePreviewer
      height="600"
      v-if="showFilePreview"
      :filename="invoice.document_url"
      :url="s3bucket + '/' + invoice.document_url"
    />
  </div>
</template>

<script>
import currency from "../../../mixins/currency";
import date from "../../../mixins/date";
import filePreviewer from "../../../components/shared/filePreviewer";

export default {
  name: "invoiceListItem",
  mixins: [currency, date],
  components: { filePreviewer },
  data() {
    return {
      showFilePreview: false,
      s3bucket: process.env.VUE_APP_S3_BUCKET_URL,
    };
  },
  props: {
    invoice: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      required: false,
      default: false,
    },
    two_line_variant: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    toggleFilePreview() {
      this.showFilePreview = !this.showFilePreview;
    },
    clicOnlistItem() {
      if (this.showFilePreview) {
        this.showFilePreview = !this.showFilePreview;
      } else this.$emit("onClick", this.invoice);
    },
  },
};
</script>

<style lang="stylus">
.noPaddingLeft /deep/ a {
  padding-left: 6px;
}
</style>

<style scoped>
.tile {
  margin: 5px;
  border-radius: 4px;
}
.tile:hover {
  background: green;
}
.tile:active {
  background: yellow;
}
</style>
